export function readFileContent(file: Blob): Promise<string> {
  const reader = new FileReader()

  return new Promise<string>((resolve, reject) => {
    // @ts-ignore
    reader.onload = event => resolve(event.target.result)
    reader.onerror = error => reject(error)
    reader.readAsText(file)
  })
}